module.exports = __webpack_public_path__ + "static/media/ithra_prime.3ea4dc33.svg";